import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getStaticData } from '../../common/api/static-data-client';

import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import StaticPage from './components/StaticPage';
import AppBanner from '../../common/components/AppBanner';

// Styles
import '../../common/scss/init.scss';

import { buildHeaders } from './builders/headers';

// Mocked props
import locales from './locales';

class StaticPageContainer extends Component {
  static NAME = 'StaticPageContainer';

  static contextTypes = {
    data: PropTypes.object
  };

  static requestAllData = async (req, domain = '') => {
    const pageName = req.path
      .split('/')
      .filter(Boolean)
      .reverse()[0];

    try {
      const staticResponse = await getStaticData(domain, pageName);

      return {
        data: staticResponse.data,
        headers: buildHeaders(staticResponse.data, req)
      };
    } catch (err) {
      return {
        data: {},
        headers: {}
      };
    }
  };

  state = {
    ...(this.context.data[StaticPageContainer.NAME] || {})
  };

  render() {
    return (
      <div>
        <StaticPage locales={locales} data={this.state} />
        <SessionExpiredModal />
        <Cookies />
        <AppBanner />
      </div>
    );
  }
}

export default StaticPageContainer;
